import {
  Button,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  mobileOnly,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';

interface VoteButtonProps {
  vote: 'up' | 'down';
  onClick: VoidFunction;
}

export const VoteButton: React.FC<React.PropsWithChildren<VoteButtonProps>> = ({
  children,
  vote,
  onClick,
}) => {
  return (
    <StyledButton onClick={onClick} variant="secondary" aria-label={undefined}>
      <IconWithMargin
        size="S"
        asset={
          vote === 'up'
            ? GenericIconName.SmileyHappy
            : GenericIconName.SmileySad
        }
      />
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  padding: 20px 40px;
  flex-direction: column;
  font-weight: ${FONT_WEIGHTS.w400};

  ${mobileOnly(
    css`
      flex-direction: row;
      text-align: left;
      padding: 20px;
    `,
  )}
`;

const IconWithMargin = styled(Icon)`
  margin-bottom: 10px;

  ${mobileOnly(
    css`
      margin-bottom: 0;
      margin-right: 10px;
    `,
  )}
`;
